import React from "react";

import { PAGES } from "../../constants/localization";
import { FEATURE_FLAGS } from "../../constants/featureFlags";
import { ROUTES } from "../../constants/clientRoutes";

// types
import { NavigationPanelListItemType } from "../../types/components";

// ui components
import InputSkeletonGroup from "../Common/Loaders/InputSkeleton";
import NavigationPanelList from "../Navigation/NavigationPanelList";

type QuickLinksProps = {
  /** react hook to update showModal value */
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  /** user's feature flags */
  featureFlags: string[];
  /** Redux state to show if initial app calls from App.js have error */
  initialApiCallErrors?: object | null;
};

const QuickLinks = ({ setShowModal, featureFlags, initialApiCallErrors }: QuickLinksProps) => {
  const links: NavigationPanelListItemType[] = [
    {
      title: PAGES.DASHBOARD.QUICK_LINKS.FX_RATES,
      featureFlag: FEATURE_FLAGS.FX_RATES,
      onClick: () => setShowModal(true),
    },
    {
      title: PAGES.DASHBOARD.QUICK_LINKS.MY_CARD_TRANSACTIONS,
      link: ROUTES.MY_CARD.RECENT_TRANSACTIONS,
    },
    {
      title: PAGES.DASHBOARD.QUICK_LINKS.PAYMENT_HISTORY,
      link: ROUTES.PAYMENTS_DISBURSEMENT_HISTORY.INDEX,
      featureFlag: FEATURE_FLAGS.PAYMENT_HISTORY,
    },
    {
      title: PAGES.DASHBOARD.QUICK_LINKS.BANK_ACCOUNTS,
      link: ROUTES.BANKS_ACCOUNTS.COUNTRY,
      featureFlag: FEATURE_FLAGS.BANK_ACCOUNTS,
    },
    {
      title: PAGES.DASHBOARD.QUICK_LINKS.CHANGE_ALLOCATION,
      link: ROUTES.ALLOCATIONS.INDEX,
      featureFlag: FEATURE_FLAGS.CHANGE_ALLOCATION,
    },
    {
      title: PAGES.DASHBOARD.QUICK_LINKS.COMPANION_CARD,
      link: ROUTES.MY_CARD.REQUEST_COMPANION_CARD,
      featureFlag: FEATURE_FLAGS.COMPANION_CARD,
    },
    {
      title: PAGES.DASHBOARD.QUICK_LINKS.WAGE_STEMENTS,
      link: ROUTES.WAGE_STATEMENTS,
      featureFlag: FEATURE_FLAGS.WAGE_STATEMENTS,
    },
  ];

  return (

    <div className="panel panel-default col-flex-1" data-testid="quick-links">
      {/* if featureFlags length is 0 and initalApiCallErrors is true, then initial api calls from App.js have finished, so remove loading state */}
      {!featureFlags.length && !initialApiCallErrors && (
        <div className="padding-top-small padding-right-small padding-bottom-small padding-left-small">
          <InputSkeletonGroup numInputs={5} direction="vertical" hideLabels={true} />
        </div>
      )}

      {featureFlags.length > 0 && (
        <NavigationPanelList links={links} featureFlags={featureFlags} dataCy="quick-links" />
      )}
    </div>

  );
};

export default QuickLinks;